import { CreateAction } from '../../../form-builder/interface/request-form-builder.model';

/**
 * Request-scoped handler for lookup create-action CTA clicks.
 * Provide on RequestComponent (or equivalent host); lookup-field injects it optionally.
 */
export abstract class TriggerActionHandler {
  abstract handle(
    createAction: CreateAction,
    parentFieldKey: string | null
  ): void;
}
